import {MultiPolygon} from 'geojson';

export enum DisputeStatus {
  PENDING= 'PENDING',
  IN_REVIEW = 'IN_REVIEW',
  RESOLVED = 'RESOLVED',
  REJECTED = 'REJECTED'
}

export type Dispute = {
  uuid?: string | undefined,
  parcelUuid: string,
  status: DisputeStatus,
  description?: string | undefined,
  geom: MultiPolygon,
  createdAt?: Date | undefined,
  updatedAt?: Date | undefined
};

export type DisputeDto = {//para recibir o enviar API
  uuid?: string,
  parcelUuid: string,
  status: DisputeStatus,
  description?: string,
  geom: MultiPolygon,
  createdAt?: string,
  updatedAt?: string
};

export const toDomain = (dispute: DisputeDto): Dispute => ({
  uuid: dispute.uuid || undefined,
  parcelUuid: dispute.parcelUuid,
  status: dispute.status,
  description: dispute.description,
  geom: dispute.geom,
  createdAt: dispute.createdAt ? new Date(dispute.createdAt) : undefined,
  updatedAt: dispute.updatedAt ? new Date(dispute.updatedAt) : undefined,
});

export const toDto = (dispute: Dispute): DisputeDto => ({
  uuid: dispute.uuid,
  parcelUuid: dispute.parcelUuid,
  status: dispute.status,
  description: dispute.description,
  geom: dispute.geom,
});